import React, { Component } from 'react';
// import React from 'react';
import LineBar from './LineBar';
import Recaptcha from 'react-recaptcha';
import Layout from './Layout';


class Advanced extends Component {

  constructor(props){
    super(props);

    this.state = {
      isVerifiled : false
    }
    
    this.recaptchLoaded = this.recaptchLoaded.bind();
    this.verifyCallback = this.verifyCallback.bind();
    this.handleSubmition = this.handleSubmition.bind();
  }

  handleSubmition = (e) =>{
    if(!this.state.isVerifiled){
      // document.getElementById("someForm").submit();
      e.preventDefault();
      alert('Please verify that you are a human!');
    }
  }

  recaptchLoaded = () =>{
    console.log('recaptcha loaded');
  }

  verifyCallback = (response) => {
    if(response){
      // console.log('fdfds');
      this.setState({
        isVerifiled: true
      });
    }
  }

  render() {
    let search = '';
    if (typeof window !== 'undefined') {
        search = window.location.search;
    }
    return (
      <Layout>
        <div className="row justify-content-between">
          <div className="col-md-5 mb-5">
            {/* <h3>
              Please give{" "}
              <a href="mailto:publift@publift.com">publift@publift.com</a>{" "}
              access to your google analytics and fill-in your details below to
              get a copy of your full business analysis
            </h3> */}
            <h3>Please fill-in your details below and Ben and Roddy will be in contact shortly to begin a full analysis</h3>

            <div className="pt-4">
              <form
                id="contactForm"
                action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
                method="POST"
                onSubmit={this.handleSubmition}
              >
                <input type="hidden" name="oid" value="00D2w00000EvNDh" />
                {/* <input type="hidden" name="retURL" value="https://publift.netlify.app/contact" /> */}
                <input type="hidden" name="retURL" value="https://publift.netlify.app/contact/?status=success" />

                <input
                  id="first_name"
                  maxLength="40"
                  name="first_name"
                  size="20"
                  type="hidden"
                />
                <input
                  id="last_name"
                  maxLength="80"
                  name="last_name"
                  size="20"
                  type="hidden"
                />
                <div className="form-group">
                  <input
                    type="hidden"
                    id="company"
                    maxLength="40"
                    name="company"
                    size="20"
                    className="form-control"
                    placeholder="Business name"
                  />
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    id="url"
                    maxLength="80"
                    name="url"
                    size="20"
                    className="form-control"
                    placeholder="Website"
                  />
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    id="email"
                    maxLength="80"
                    name="email"
                    size="20"
                    className="form-control"
                    placeholder="Email"
                    required
                  />
                </div>

                <div className="form-group">
                  <input
                    type="hidden"
                    id="phone"
                    maxLength="40"
                    name="phone"
                    size="20"
                    className="form-control"
                    placeholder="Phone"
                  />
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    id="country"
                    maxLength="40"
                    name="country"
                    size="20"
                    className="form-control"
                    placeholder="Country"
                    required
                  />
                </div>
                <div className="form-group">
                  {/* <div className="g-recaptcha" data-sitekey=""></div> */}
                  <Recaptcha
                    sitekey="6Ld3pNEZAAAAADQcLMsZKzCa4nliMtadfuXuytGN"
                    render="explicit"
                    verifyCallback={this.verifyCallback}
                    onloadCallback={this.recaptchLoaded}
                  />
                </div>
                <div className="form-group">
                  <button
                    type="submit"
                    name="submit"
                    className="btn btn-primary border-0 btn-block"
                  >
                    Get in-depth analysis
                  </button>
                </div>
              </form>
              {search && search ? (
                <div className="success-message text-success">
                  Mesage successfully submitted! We will contact you as soon as
                  possible.
                </div>
              ) : (
                ""
              )}
            </div>

            <div className="text-center pt-2 px-3">
              <p>
                All the information is captured in accordance to our privacy
                policy.
              </p>
            </div>
          </div>
          <div className="col-md-6 mb-5">
            <LineBar
              avrNum={this.props.avrNum}
              AvrCPM={this.props.AvrCPM}
              AdUnitsPP={this.props.AdUnitsPP}
              currentAdSet={this.props.currentAdSet}
            />
          </div>
        </div>
      </Layout>
    );
  }
}

export default Advanced;